import { render, staticRenderFns } from "./ParticipantScreenShare.vue?vue&type=template&id=16ee0463&scoped=true&"
import script from "./ParticipantScreenShare.vue?vue&type=script&lang=js&"
export * from "./ParticipantScreenShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ee0463",
  null
  
)

export default component.exports